<template>
  <v-dialog
    v-model="toggle"
    scrollable
    transition="slide-y-reverse-transition"
    style="max-height: 90vh !important;"
    light
    fullscreen
  >
    <v-card class="privacy-content white">
      <v-btn
        absolute
        top
        right
        fab
        icon
        class="mt-8 mr-n4"
        @click="close"
      >
        <v-icon>{{ icons.mdiClose }}</v-icon>
      </v-btn>
      <v-card-text 
        class="py-4 grey--text text--darken-3"
      >
        <icon-base
          width="37"
          height="43"
          name="hive"
          class="hive mt-4 mb-8 black--text"
          style="height: 32px;"
        >
          <brand-symbol />
        </icon-base>

        <component :is="content" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          color="grey"
          text
          @click="close"
        >
          Voltar
        </v-btn>
        <!-- <v-spacer />
        <v-btn
          color="primary darken-1"
          text
          @click="acceptTOS(true)"
        >
          Aceitar
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

  .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 90% !important;
  }

  .privacy-content {
    border-radius: 0 !important;
  }

  .privacy-content .subtitle-2 { 
    margin-top: 32px;
    margin-bottom: 16px;
  }
  .privacy-content .indent { 
    padding-left: 8px;
  }
  .privacy-content ul { 
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .privacy-content ol { 
    padding: 1rem 0 0;
    list-style-position: outside;
    counter-reset: item;
  }
  .privacy-content ol li { 
    display: inline-block;
    padding-bottom: 1rem;
  }
  .privacy-content ol>li:before {
    font-weight: 700;
    content: counters(item, ".") ". ";
    counter-increment: item;
  }
  .privacy-content ol ul {
    padding: 1rem 0 0 1rem;
    list-style-position: outside;
    list-style-type: square !important;
  }
  .privacy-content ol ul>li:before {
    content: '■ ';
  }
  .privacy-content a {
    color: var(--v-secondary-base);
  }

</style>

<script>
  // Utilities
  import {
    mdiClose
  } from '@mdi/js'
  import { sync } from 'vuex-pathify'
  import services from '@/services.js'

  export default {
    name: 'PrivacyPolicy',

    data: () => ({
      icons: {
        mdiClose
      },
      contents: {
        // '4': 'es',
        'es': 'spanish',
        'es-py': 'spanish',
        'es-ar': 'spanish',
        // '1:5': 'org-1-fleet-5',
        // '2': 'org-2'
      },
    }),

    computed: {
      toggle: sync('app/views@privacy.toggle'),
      user: sync('user'),

      content () {
        const contents = this.contents;
        const profile = this.user.profile;
        return this.getContent(profile, contents);
      }
    },

    methods: {
      ...services,

      close () {
        this.toggle = false;
        if (this.$route.name=='Política de Privacidade') this.$router.push('/');
      },

    },

    components: {
      Default: () => import('@/views/help/privacy/Default'),
      Spanish: () => import('@/views/help/privacy/Spanish'),
      // Org1Fleet5: () => import('@/views/help/terms/TermsOrg1Fleet5'),
      // Org2: () => import('@/views/help/terms/TermsOrg2'),
    },

  }
</script>
